"use client";
import React from "react";
import { cn } from "utils";

export interface MobileStackPrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  children: React.ReactNode;
}

/**
 * 栈导航页底部固定区域的全宽主按钮，支持 `loading` / `disabled`。
 */
export const MobileStackPrimaryButton: React.FC<
  MobileStackPrimaryButtonProps
> = ({ loading, children, className, disabled, ...props }) => {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      data-loading={loading}
      className={cn(
        "button flex h-11 w-full items-center justify-center gap-1 rounded-lg button_m group",
        "bg-black text-content_inverse_primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
